// Constants for Power BI Security List
const POWERBI_SECURITY_DATA = {
  POWERBI_SECURITY_DATA_LOAD: "POWERBI_SECURITY_DATA_LOAD",
  POWERBI_SECURITY_DATA_SUCCESS: "POWERBI_SECURITY_DATA_SUCCESS",
  POWERBI_SECURITY_DATA_FAIL: "POWERBI_SECURITY_DATA_FAIL",
};

const POWERBI_SECURITY_GET_API = "/powerbi/roles/access";

// Constants for Single Power BI Security Detail
const POWERBI_SECURITY_GET_DATA = {
  POWERBI_SECURITY_GET_DATA_LOAD: "POWERBI_SECURITY_GET_DATA_LOAD",
  POWERBI_SECURITY_GET_DATA_SUCCESS: "POWERBI_SECURITY_GET_DATA_SUCCESS",
  POWERBI_SECURITY_GET_DATA_FAIL: "POWERBI_SECURITY_GET_DATA_FAIL",
};

const POWERBI_SECURITY_GET_DETAIL_API = "/powerbi/roles/access/";

// Constants for Add Power BI Security
const POWERBI_SECURITY_ADD_DATA = {
  POWERBI_SECURITY_ADD_DATA_LOAD: "POWERBI_SECURITY_ADD_DATA_LOAD",
  POWERBI_SECURITY_ADD_DATA_SUCCESS: "POWERBI_SECURITY_ADD_DATA_SUCCESS",
  POWERBI_SECURITY_ADD_DATA_FAIL: "POWERBI_SECURITY_ADD_DATA_FAIL",
};

const POWERBI_SECURITY_ADD_POST_API = "/powerbi/roles/access";

// Constants for Update Power BI Security
const POWERBI_SECURITY_UPDATE_DATA = {
  POWERBI_SECURITY_UPDATE_DATA_LOAD: "POWERBI_SECURITY_UPDATE_DATA_LOAD",
  POWERBI_SECURITY_UPDATE_DATA_SUCCESS: "POWERBI_SECURITY_UPDATE_DATA_SUCCESS",
  POWERBI_SECURITY_UPDATE_DATA_FAIL: "POWERBI_SECURITY_UPDATE_DATA_FAIL",
};

const POWERBI_SECURITY_UPDATE_PUT_API = "/powerbi/roles/access/";

// Constants for Delete Power BI Security
const POWERBI_SECURITY_DELETE_DATA = {
  POWERBI_SECURITY_DELETE_DATA_LOAD: "POWERBI_SECURITY_DELETE_DATA_LOAD",
  POWERBI_SECURITY_DELETE_DATA_SUCCESS: "POWERBI_SECURITY_DELETE_DATA_SUCCESS",
  POWERBI_SECURITY_DELETE_DATA_FAIL: "POWERBI_SECURITY_DELETE_DATA_FAIL",
};

const POWERBI_SECURITY_DELETE_API = "/powerbi/roles/access/";

// Constants for PowerBI Roles List
const POWERBI_ROLES_DATA = {
  POWERBI_ROLES_DATA_LOAD: "POWERBI_ROLES_DATA_LOAD",
  POWERBI_ROLES_DATA_SUCCESS: "POWERBI_ROLES_DATA_SUCCESS",
  POWERBI_ROLES_DATA_FAIL: "POWERBI_ROLES_DATA_FAIL",
};

const POWERBI_ROLES_GET_API = "/powerbi/roles";

// Constants for Update Sequence Order
const POWERBI_SECURITY_UPDATE_SEQUENCE = {
  POWERBI_SECURITY_UPDATE_SEQUENCE_LOAD: "POWERBI_SECURITY_UPDATE_SEQUENCE_LOAD",
  POWERBI_SECURITY_UPDATE_SEQUENCE_SUCCESS: "POWERBI_SECURITY_UPDATE_SEQUENCE_SUCCESS",
  POWERBI_SECURITY_UPDATE_SEQUENCE_FAIL: "POWERBI_SECURITY_UPDATE_SEQUENCE_FAIL",
};

const POWERBI_SECURITY_UPDATE_SEQUENCE_API = "/powerbi/updatesequence";

// Constants for Sync Pages
const POWERBI_SECURITY_SYNC_PAGES = {
  POWERBI_SECURITY_SYNC_PAGES_LOAD: "POWERBI_SECURITY_SYNC_PAGES_LOAD",
  POWERBI_SECURITY_SYNC_PAGES_SUCCESS: "POWERBI_SECURITY_SYNC_PAGES_SUCCESS",
  POWERBI_SECURITY_SYNC_PAGES_FAIL: "POWERBI_SECURITY_SYNC_PAGES_FAIL",
};

const POWERBI_SECURITY_SYNC_PAGES_API = "/powerbi/sync-pages";

// Constants for Get Report Pages
const POWERBI_SECURITY_GET_REPORT_PAGES = {
  POWERBI_SECURITY_GET_REPORT_PAGES_LOAD: "POWERBI_SECURITY_GET_REPORT_PAGES_LOAD",
  POWERBI_SECURITY_GET_REPORT_PAGES_SUCCESS: "POWERBI_SECURITY_GET_REPORT_PAGES_SUCCESS",
  POWERBI_SECURITY_GET_REPORT_PAGES_FAIL: "POWERBI_SECURITY_GET_REPORT_PAGES_FAIL",
};

const POWERBI_SECURITY_GET_REPORT_PAGES_API = "powerbi/pages/report";

export {
  POWERBI_SECURITY_DATA,
  POWERBI_SECURITY_GET_API,
  POWERBI_SECURITY_GET_DATA,
  POWERBI_SECURITY_GET_DETAIL_API,
  POWERBI_SECURITY_ADD_DATA,
  POWERBI_SECURITY_ADD_POST_API,
  POWERBI_SECURITY_UPDATE_DATA,
  POWERBI_SECURITY_UPDATE_PUT_API,
  POWERBI_SECURITY_DELETE_DATA,
  POWERBI_SECURITY_DELETE_API,
  POWERBI_ROLES_DATA,
  POWERBI_ROLES_GET_API,
  POWERBI_SECURITY_UPDATE_SEQUENCE,
  POWERBI_SECURITY_UPDATE_SEQUENCE_API,
  POWERBI_SECURITY_SYNC_PAGES,
  POWERBI_SECURITY_SYNC_PAGES_API,
  POWERBI_SECURITY_GET_REPORT_PAGES,
  POWERBI_SECURITY_GET_REPORT_PAGES_API,
};
